import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/mall/goodsList.vue'
createPage(Page)